/**
 * API-related constants
 */

/**
 * Resource types available in the API
 * Used for cache key generation and invalidation
 */
export enum ResourceType {
  APPLICATIONS = 'applications',
  APPROVALS = 'approvals',
  CONTRACTS = 'contracts',
  LABOR_CATEGORIES = 'labor-categories',
  OUT_OF_OFFICE = 'out-of-office',
  ROLE_ASSIGNMENTS = 'role-assignments',
  ROSTER = 'roster',
  USERS = 'users',
}

/**
 * API path prefixes
 */
export enum ApiPrefix {
  AUTH = '/api/v1/auth',
  V1 = '/api/v1',
}

/**
 * Resource base paths
 */
export enum ResourcePath {
  APPLICATIONS = '/api/v1/applications',
  CONTRACTS = '/api/v1/contracts',
  USERS = '/api/v1/users',
}

/**
 * Nested resource path templates
 */
export enum NestedResourcePath {
  CONTRACT_CORS = '/api/v1/contracts/{contractId}/cors',
  CONTRACT_LABOR_CATEGORIES = '/api/v1/contracts/{contractId}/labor-categories',
  CONTRACT_ROLE_ASSIGNMENTS = '/api/v1/contracts/{contractId}/role-assignments',
  CONTRACT_ROSTER = '/api/v1/contracts/{contractId}/roster',
}

/**
 * Query key prefixes for React Query cache management
 */
export enum QueryKeyPrefix {
  AUTH = 'auth',
  DETAIL = 'detail',
  LIST = 'list',
  NESTED = 'nested',
}

/**
 * Default stale time for queries (5 minutes)
 */
export const DEFAULT_STALE_TIME = 5 * 60 * 1000;

/**
 * Default retry count for failed queries
 */
export const DEFAULT_RETRY_COUNT = 1;

/**
 * Predefined React Query refetch intervals. Pass a value, `false`, or a function
 * that returns a value/`false` as `refetchInterval`.
 */
export const REFETCH_INTERVAL = {
  refetchEvery3Seconds: 3_000,
  refetchEvery5Minutes: 5 * 60 * 1000,
  refetchEvery5Seconds: 5_000,
  refetchEvery10Seconds: 10_000,
  refetchEvery30Seconds: 30_000,
  refetchEveryMinute: 60_000,
} as const;

export type QueryRefetchIntervals = (typeof REFETCH_INTERVAL)[keyof typeof REFETCH_INTERVAL];
